<div class="position-relative tab-content" *ngIf="tabConfig.isTabsEnabled">
    <!-- <span (cclClick)="moveLeft()" title="Move Left" class="tab-slide-button left fa fa-arrow-left"></span> -->

    <!-- <drag-scroll scrollbar-hidden="true" #nav [ngClass]="['h-55px']" class="tab-row"> -->
        <div class="tab-container">
            <div title="All Days"
                drag-scroll-item
                (cclClick)="selectTab($event, 'allDay')"
                [ngClass]="['tab-data', 'ta-center','tab-dimension']"
                *ngIf="selectedTabData == 'allDay'"
            >
                <div
                    [ngClass]="{
                        'tab-element active': true,
                        'tab-element-custom active': true,
                        'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                        'tab-element-custom-underline': tabConfig.tabStyle !== 'tab',
                        active: true
                    }"
                    id="add-day-label"
                >
                {{ 'tab_section.all_days' | translate }}
                </div>
            </div>
            <div title="All Days"
                drag-scroll-item
                (cclClick)="selectTab($event, 'allDay')"
                [ngClass]="['tab-data', 'ta-center', 'tab-dimension']"
                *ngIf="selectedTabData != 'allDay'"
            >
                <div
                    [ngClass]="{
                        'tab-element': true,
                        'tab-element-custom': true,
                        'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                        'tab-element-custom-underline': tabConfig.tabStyle !== 'tab'
                    }"
                    id="add-day-label"
                >
                {{ 'tab_section.all_days' | translate }}
                </div>
            </div>
            <div drag-scroll-item class="tab-data" *ngFor="let tabDate of tabData; let i = index">
                <div title="{{ tabDate.label }}"
                    (cclClick)="selectTab($event, tabDate.id)"
                    [ngClass]="['ta-center', 'tab-dimension']"
                    *ngIf="selectedTabData == tabDate.id"
                >
                    <div
                        [ngClass]="{
                            'tab-element': true,
                            'active tab-element-custom active': true,
                            'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                            'tab-element-custom-underline': tabConfig.tabStyle !== 'tab',
                            active: true
                        }"
                    >
                    {{ tabDate.label }}
                    </div>
                </div>

                <div title="{{ tabDate.label }}"
                    (cclClick)="selectTab($event, tabDate.id)"
                    [ngClass]="['ta-center', 'tab-dimension']"
                    *ngIf="selectedTabData != tabDate.id"
                >
                    <div
                        [ngClass]="{
                            'tab-element': true,
                            'tab-element-custom': true,
                            'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                            'tab-element-custom-underline': tabConfig.tabStyle !== 'tab'
                        }"
                    >
                        {{ tabDate.label }}
                    </div>
                </div>
            </div>
        </div>
    <!-- </drag-scroll> -->

    <!-- <span (cclClick)="moveRight()" title="Move Right" class="tab-slide-button right fa fa-arrow-right"></span> -->
</div>
<div class="clearfix"></div>
